if (!customElements.get('product-recommendations')) {
	customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.onSwatchChange = this.onSwatchChange.bind(this);
    }

    connectedCallback() {
      this.syncCards();
      this.addEventListener('change', this.onSwatchChange);
      // Globo can add its controls and rewrite product links after the cards load.
      this.cardObserver = new MutationObserver(() => this.syncCards());
      this.cardObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => {
            if (!response.ok) throw new Error(`Product recommendations request failed: ${response.status}`);
            return response.text();
          })
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            // Keep the initial Liquid products unless the response contains a product list.
            if (recommendations && recommendations.querySelector('.recommendation-list')) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (this.querySelector('.recommendation-list')) {
              this.classList.add('product-recommendations--loaded');
              this.classList.remove('hidden');
            } else {
              this.classList.add('hidden');
            }
          })
          .catch(e => {
            console.error(e);
            if (!this.querySelector('.recommendation-list')) this.classList.add('hidden');
          });
      }

      this.intersectionObserver = new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'});
      this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      this.cardObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.removeEventListener('change', this.onSwatchChange);
    }

    syncCards() {
      this.querySelectorAll('.card').forEach(card => {
        if (card.querySelector('.swatches-globo input[type="radio"]')) {
          card.querySelectorAll('card-product-colors').forEach(swatches => swatches.remove());
        }

        card.querySelectorAll('a[href*="?"]').forEach(link => {
          const url = new URL(link.getAttribute('href'), document.baseURI);
          if (url.origin === location.origin && url.pathname.includes('/products/')) {
            url.search = '';
            link.setAttribute('href', url.href);
          }
        });
      });
    }

    onSwatchChange(event) {
      const input = event.target;
      if (!input.matches('.swatches-globo input[type="radio"]') || !input.checked) return;

      const card = input.closest('.card');
      const imageUrl = input.closest('.swatches-options')?.getAttribute('productimage');
      const image = card?.querySelector('.media img');
      if (image && imageUrl) {
        image.src = imageUrl;
        image.srcset = imageUrl;
        const title = input.closest('.swatches-globo').getAttribute('product-swatch-title');
        if (title) image.alt = `${title} - ${input.value}`;
        // Keep the selected colour visible even when the card has a hover image.
        card.classList.add('ignore-second-image');
      }
      this.syncCards();
    }
  });
}
